"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const createProductsApp_1 = require("./createProductsApp");
const ProductList_hartwall_1 = require("./ProductList-hartwall");
const BrandList_hartwall_1 = require("./BrandList-hartwall");
const CategoryList_1 = require("./CategoryList");
exports.default = (0, createProductsApp_1.default)({
    ProductListComponent: ProductList_hartwall_1.default,
    BrandListComponent: BrandList_hartwall_1.default,
    CategoryListComponent: CategoryList_1.default,
});
